document.addEventListener("DOMContentLoaded", function () {
    let priceTemplate = document.querySelector('product-price')
    let priceBlock = document.querySelector(".shopify-app-block .price")

    if (priceBlock && !priceBlock.classList.contains("hide")) {
        priceTemplate.style.display = "none"
    }

       setTimeout(() => {
        let priceTemplate = document.querySelector('product-price')
    let priceBlock = document.querySelector(".shopify-app-block .price")

    if (priceBlock && !priceBlock.classList.contains("hide")) {
        priceTemplate.style.display = "none"
    }
       },300);
})